<template>
<div class="chapter">
<div class="inner_page">
<div class="pbba" id="calibre_pb_6"></div>
<div class="lgl"><h1 class="nobreak" id="calibre_toc_2"><a id="Page_1"></a>    PART ONE   <br class="sub-head"/> <span class="lgl">Red and Black Laughter</span></h1></div>
<div class="blockquote30em">
<p class="noindent"><span class="it">The only source of the true Ridiculous (as it appears to me) is
affectation.</span></p>
<p class="line6">HENRY FIELDING</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 20210135e_split_006.vue?158f6338